//import React, { useState, useEffect } from "react";
//import { FaRegWindowClose } from "react-icons/fa";
//import Loading from "../../component/Loading/Loading";
//import AlertMsg from "../../component/AlertMsg/AlertMsg";
//import { useSelector } from "react-redux";
//import { AiOutlineSortAscending } from "react-icons/ai";
//import Pagination from "../../utils/Pagenation/Pagenation";
//import useAxiosInstance from "../../services/useAxiosInstance";
//import { Plus, Pencil, Trash2, Search } from "lucide-react";
//import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

//const ServiceType = () => {
//  const axiosInstance = useAxiosInstance();
//  const [serviceTypes, setServiceTypes] = useState([]);
//  const [isLoading, setIsLoading] = useState(true);
//  const [selectedServiceType, setSelectedServiceType] = useState(null);
//  const [showDeleteModal, setShowDeleteModal] = useState(false);
//  const [showAddModal, setShowAddModal] = useState(false);
//  const [formdata, setFormdata] = useState({
//    name: "",
//    activestatus: true,
//    id: 0,
//  });
//  const [errors, setErrors] = useState({});
//  const [isEditing, setIsEditing] = useState(false);
//  const communityId = useSelector((state) => state.auth.communityId);
//  const userId = useSelector((state) => state.auth.userId);

//  const [alert, setAlert] = useState({ message: '', type: '', visible: false });

//  useEffect(() => {
//    const fetchServiceTypes = async () => {
//      setIsLoading(true);
//      try {
//        const response = await axiosInstance.get(`/api/public/servicetype/getAll`);
//        setServiceTypes(response.data);
//      } catch (error) {
//        console.error("Error fetching service types:", error);
//        setAlert({ message: 'Failed to fetch service types.', type: 'error', visible: true });
//      } finally {
//        setIsLoading(false);
//      }
//    };

//    fetchServiceTypes();
//  }, [userId, communityId]);

//  const handleView = (serviceType) => {
//    setSelectedServiceType(serviceType);
//    setShowDeleteModal(false);
//  };

//  const confirmDelete = (id) => {
//    console.log(`Deleting service type with ID: ${id}`);
//    setShowDeleteModal(false);
//    setIsLoading(true);
//    axiosInstance
//      .delete(`/api/public/servicetype/delete/${id}`)
//      .then((response) => {
//        setServiceTypes(serviceTypes.filter((st) => st.id !== id));
//        setAlert({ message: 'Service type deleted successfully.', type: 'success', visible: true });
//      })
//      .catch((error) => {
//        console.error("Error deleting service type:", error);
//        setAlert({ message: 'Failed to delete service type.', type: 'error', visible: true });
//      })
//      .finally(() => {
//        setIsLoading(false);
//      });
//  };

//  const closeModal = () => {
//    setSelectedServiceType(null);
//    setShowDeleteModal(false);
//    setShowAddModal(false);
//    setFormdata({ name: "", activestatus: true, id: 0 });
//    setErrors({});
//    setIsEditing(false);
//  };

//  const handleAddServiceType = () => {
//    setShowAddModal(true);
//    setIsEditing(false);
//  };

//  const handleEditServiceType = (serviceType) => {
//    setFormdata({
//      name: serviceType.name,
//      activestatus: serviceType.activestatus,
//      id: serviceType.id,
//    });
//    setShowAddModal(true);
//    setIsEditing(true);
//  };

//  const validate = () => {
//    let errors = {};
//    if (!formdata.name) {
//      errors.name = "Service Type Name is required";
//    } else if (formdata.name.length < 3) {
//      errors.name = "Service Type Name must be at least 3 characters long";
//    }
//    return errors;
//  };

//  const handleAddNewServiceType = (e) => {
//    e.preventDefault();

//    const validationErrors = validate();
//    if (Object.keys(validationErrors).length > 0) {
//      setErrors(validationErrors);
//      return;
//    }

//    setShowAddModal(false);
//    setIsLoading(true);

//    axiosInstance
//      .post(`/api/public/servicetype/add`, formdata)
//      .then((response) => {
//        console.log("Service type added successfully:", response.data);
//        setServiceTypes([...serviceTypes, response.data]);
//        setAlert({ message: 'Service type added successfully.', type: 'success', visible: true });
//        setIsLoading(false);
//      })
//      .catch((error) => {
//        console.error(
//          "Error adding new service type:",
//          error.response?.data || error.message
//        );
//        setAlert({ message: `Failed to add new service type: ${error.response?.data?.message || error.message}`, type: 'error', visible: true });
//        setIsLoading(false);
//      });
//  };

//  const handleEditSubmit = (e) => {
//    e.preventDefault();

//    const validationErrors = validate();
//    if (Object.keys(validationErrors).length > 0) {
//      setErrors(validationErrors);
//      return;
//    }

//    setIsEditing(false);
//    setShowAddModal(false);
//    setIsLoading(true);

//    axiosInstance
//      .put(`/api/public/servicetype/update/${formdata.id}`, formdata)
//      .then((response) => {
//        console.log("Service type updated successfully:", response.data);
//        setServiceTypes(
//          serviceTypes.map((st) =>
//            st.id === formdata.id ? response.data : st
//          )
//        );
//        setAlert({ message: 'Service type updated successfully.', type: 'success', visible: true });
//        setIsLoading(false);
//      })
//      .catch((error) => {
//        console.error(
//          "Error updating service type:",
//          error.response?.data || error.message
//        );
//        setAlert({ message: `Failed to update service type: ${error.response?.data?.message || error.message}`, type: 'error', visible: true });
//        setIsLoading(false);
//      });
//  };

//  const [currentPage, setCurrentPage] = useState(0);
//  const itemsPerPage = 5;
//  const [sortOrder, setSortOrder] = useState('none');

//  const handleSort = () => {
//    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
//  };

//  const sortedServiceTypes = [...serviceTypes].sort((a, b) => {
//    if (sortOrder === 'asc') {
//      return a.name.localeCompare(b.name);
//    } else if (sortOrder === 'desc') {
//      return b.name.localeCompare(a.name);
//    }
//    return 0;
//  });

//  const pageCount = Math.ceil(sortedServiceTypes.length / itemsPerPage);
//  const currentServiceTypes = sortedServiceTypes.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//  // Modal footer components
//  const addModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//        type="button"
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={isEditing ? handleEditSubmit : handleAddNewServiceType}
//        type="button"
//      >
//        {isEditing ? "Update" : "Add"}
//      </button>
//    </div>
//  );

//  const deleteModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//        onClick={() => confirmDelete(selectedServiceType.id)}
//      >
//        Delete
//      </button>
//    </div>
//  );

//  return (
//    <div className="bg-gray-50 min-h-screen md:p-4">
//      {isLoading && <Loading />}
//      {!isLoading && (
//        <div className="max-w-7xl mx-auto">
//          {alert.visible && (
//            <AlertMsg
//              message={alert.message}
//              type={alert.type}
//              onClose={() => setAlert({ ...alert, visible: false })}
//            />
//          )}
//          <div className="flex justify-between items-center mb-6">
//            <h1 className="text-2xl font-bold text-gray-800">Service Types</h1>
//            <div className="flex items-center">
//              <button
//                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//                onClick={handleAddServiceType}
//              >
//                <Plus size={18} />
//                <span>Add</span>
//              </button>
//            </div>
//          </div>

//          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">


//            <div className="overflow-x-auto">
//              <table className="min-w-full divide-y divide-gray-200">
//                <thead className="bg-blue-400">
//                  <tr>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
//                      Name
//                      <button
//                        onClick={handleSort}
//                      >
//                        <AiOutlineSortAscending className="inline ml-1" />
//                      </button>
//                    </th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider text-center">
//                      Action
//                    </th>
//                  </tr>
//                </thead>
//                <tbody className="bg-white divide-y divide-gray-200">
//                  {currentServiceTypes.length === 0 ? (
//                    <tr>
//                      <td colSpan="2" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                    </tr>
//                  ) : (
//                    currentServiceTypes.map((serviceType) => (
//                      <tr key={serviceType.id} className="hover:bg-gray-50">
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{serviceType.name}</td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex justify-center gap-3">
//                          <button
//                            className="text-gray-500 hover:text-gray-700"
//                            onClick={() => handleEditServiceType(serviceType)}
//                            title="Edit Type"
//                          >
//                            <Pencil size={18} />
//                          </button>
//                          <button
//                            className="text-red-500 hover:text-red-700"
//                            onClick={() => {
//                              setSelectedServiceType(serviceType);
//                              setShowDeleteModal(true);
//                            }}
//                            title="Delete Type"
//                          >
//                            <Trash2 size={18} />
//                          </button>
//                        </td>
//                      </tr>
//                    ))
//                  )}
//                </tbody>
//              </table>
//            </div>

//            <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
//              <div className="text-sm text-gray-700">
//                Page {currentPage + 1} of {pageCount}
//              </div>
//              <div className="flex-1 flex justify-end">
//                <Pagination
//                  currentPage={currentPage}
//                  pageCount={pageCount}
//                  setCurrentPage={setCurrentPage}
//                />
//              </div>
//            </div>
//          </div>
//        </div>
//      )}

//      {/* Add/Edit Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showAddModal}
//        onClose={closeModal}
//        title={isEditing ? "Edit Service Type" : "Add New Service Type"}
//        size="md"
//        footer={addModalFooter}
//      >
//        <div className="space-y-4">
//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Service Type Name <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              placeholder="Enter Service Type Name"
//              value={formdata.name}
//              onChange={(e) =>
//                setFormdata({ ...formdata, name: e.target.value })
//              }
//              className={`w-full rounded-md border ${errors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {errors.name && (
//              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
//            )}
//          </div>
//          <div className="text-sm text-red-500">* indicates required field</div>
//        </div>
//      </GlassmorphicModal>

//      {/* Delete Confirmation Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showDeleteModal}
//        onClose={closeModal}
//        title="Confirm Delete"
//        size="sm"
//        footer={deleteModalFooter}
//      >
//        <p className="text-gray-700">
//          Are you sure you want to delete this service type? This action is permanent and cannot be undone.
//        </p>
//      </GlassmorphicModal>
//    </div>
//  );
//};

//export default ServiceType;

import React, { useState, useEffect } from "react";
import { FaRegWindowClose } from "react-icons/fa";
import Loading from "../../component/Loading/Loading";
import AlertMsg from "../../component/AlertMsg/AlertMsg";
import { useSelector } from "react-redux";
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import useAxiosInstance from "../../services/useAxiosInstance";
import { Plus, Pencil, Trash2, Search } from "lucide-react";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const ServiceType = () => {
    const axiosInstance = useAxiosInstance();
    const [serviceTypes, setServiceTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedServiceType, setSelectedServiceType] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [formdata, setFormdata] = useState({
        name: "",
        activestatus: true,
        id: 0,
    });
    const [errors, setErrors] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);

    const [alert, setAlert] = useState({ message: '', type: '', visible: false });

    useEffect(() => {
        const fetchServiceTypes = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get(`/api/public/servicetype/getAll`);
                setServiceTypes(response.data);
            } catch (error) {
                console.error("Error fetching service types:", error);
                setAlert({ message: 'Failed to fetch service types.', type: 'error', visible: true });
            } finally {
                setIsLoading(false);
            }
        };

        fetchServiceTypes();
    }, [userId, communityId]);

    const handleView = (serviceType) => {
        setSelectedServiceType(serviceType);
        setShowDeleteModal(false);
    };

    const confirmDelete = (id) => {
        console.log(`Deleting service type with ID: ${id}`);
        setShowDeleteModal(false);
        setIsLoading(true);
        axiosInstance
            .delete(`/api/public/servicetype/delete/${id}`)
            .then((response) => {
                setServiceTypes(serviceTypes.filter((st) => st.id !== id));
                setAlert({ message: 'Service type deleted successfully.', type: 'success', visible: true });
            })
            .catch((error) => {
                console.error("Error deleting service type:", error);
                setAlert({ message: 'Failed to delete service type.', type: 'error', visible: true });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const closeModal = () => {
        setSelectedServiceType(null);
        setShowDeleteModal(false);
        setShowAddModal(false);
        setFormdata({ name: "", activestatus: true, id: 0 });
        setErrors({});
        setIsEditing(false);
    };

    const handleAddServiceType = () => {
        setShowAddModal(true);
        setIsEditing(false);
        setFormdata({ name: "", activestatus: true, id: 0 });
    };

    const handleEditServiceType = (serviceType) => {
        setFormdata({
            name: serviceType.name,
            activestatus: serviceType.activestatus,
            id: serviceType.id,
        });
        setShowAddModal(true);
        setIsEditing(true);
    };

    const validate = () => {
        let errors = {};
        if (!formdata.name) {
            errors.name = "Service Type Name is required";
        } else if (formdata.name.length < 3) {
            errors.name = "Service Type Name must be at least 3 characters long";
        }
        return errors;
    };

    const handleAddNewServiceType = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setShowAddModal(false);
        setIsLoading(true);

        axiosInstance
            .post(`/api/public/servicetype/add`, formdata)
            .then((response) => {
                console.log("Service type added successfully:", response.data);
                setServiceTypes([...serviceTypes, response.data]);
                setAlert({ message: 'Service type added successfully.', type: 'success', visible: true });
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(
                    "Error adding new service type:",
                    error.response?.data || error.message
                );
                setAlert({ message: `Failed to add new service type: ${error.response?.data?.message || error.message}`, type: 'error', visible: true });
                setIsLoading(false);
            });
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setIsEditing(false);
        setShowAddModal(false);
        setIsLoading(true);

        axiosInstance
            .put(`/api/public/servicetype/update/${formdata.id}`, formdata)
            .then((response) => {
                console.log("Service type updated successfully:", response.data);
                setServiceTypes(
                    serviceTypes.map((st) =>
                        st.id === formdata.id ? response.data : st
                    )
                );
                setAlert({ message: 'Service type updated successfully.', type: 'success', visible: true });
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(
                    "Error updating service type:",
                    error.response?.data || error.message
                );
                setAlert({ message: `Failed to update service type: ${error.response?.data?.message || error.message}`, type: 'error', visible: true });
                setIsLoading(false);
            });
    };

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [sortOrder, setSortOrder] = useState('none');

    const handleSort = () => {
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const sortedServiceTypes = [...serviceTypes].sort((a, b) => {
        if (sortOrder === 'asc') {
            return a.name.localeCompare(b.name);
        } else if (sortOrder === 'desc') {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    const pageCount = Math.ceil(sortedServiceTypes.length / itemsPerPage);
    const currentServiceTypes = sortedServiceTypes.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    // Modal footer components
    const addModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
                type="button"
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={isEditing ? handleEditSubmit : handleAddNewServiceType}
                type="button"
            >
                {isEditing ? "Update" : "Add"}
            </button>
        </div>
    );

    const deleteModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={() => confirmDelete(selectedServiceType.id)}
            >
                Delete
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {isLoading && <Loading />}
            {!isLoading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Service Types</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={handleAddServiceType}
                            >
                                <Plus size={18} />
                                <span>Add Service</span>
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            Name
                                            <button
                                                onClick={handleSort}
                                            >
                                                <AiOutlineSortAscending className="inline ml-1" />
                                            </button>
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            Active Status
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider ">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {currentServiceTypes.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : (
                                        currentServiceTypes.map((serviceType) => (
                                            <tr key={serviceType.id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{serviceType.name}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-left">
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${serviceType.activestatus
                                                            ? 'text-green-800 bg-green-100'
                                                            : 'text-red-800 bg-red-100'
                                                        }`}>
                                                        {serviceType.activestatus ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex justify-start gap-3 ">
                                                    <button
                                                        className="text-gray-500 hover:text-gray-700"
                                                        onClick={() => handleEditServiceType(serviceType)}
                                                        title="Edit Type"
                                                    >
                                                        <Pencil size={18} />
                                                    </button>
                                                    {/* <button
                            className="text-red-500 hover:text-red-700"
                            onClick={() => {
                              setSelectedServiceType(serviceType);
                              setShowDeleteModal(true);
                            }}
                            title="Delete Type"
                          >
                            <Trash2 size={18} />
                          </button> */}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add/Edit Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showAddModal}
                onClose={closeModal}
                title={isEditing ? "Edit Service Type" : "Add New Service Type"}
                size="md"
                footer={addModalFooter}
            >
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Service Type Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Service Type Name"
                            value={formdata.name}
                            maxLength={100}
                            onChange={(e) =>
                                setFormdata({ ...formdata, name: e.target.value })
                            }
                            className={`w-full rounded-md border ${errors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {errors.name && (
                            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                        )}
                    </div>

                    {formdata.id ? (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-3">Active Status:</label>
                            <div className="flex space-x-6">
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="activestatus"
                                        checked={formdata.activestatus === true}
                                        onChange={() =>
                                            setFormdata({ ...formdata, activestatus: true })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">Active</span>
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="activestatus"
                                        checked={formdata.activestatus === false}
                                        onChange={() =>
                                            setFormdata({ ...formdata, activestatus: false })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <span className="ml-2 text-sm text-gray-700">Inactive</span>
                                </label>
                            </div>
                        </div>
                    ) : null}

                    <div className="text-sm text-red-500">* indicates required field</div>
                </div>
            </GlassmorphicModal>

            {/* Delete Confirmation Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showDeleteModal}
                onClose={closeModal}
                title="Confirm Delete"
                size="sm"
                footer={deleteModalFooter}
            >
                <p className="text-gray-700">
                    Are you sure you want to delete this service type? This action is permanent and cannot be undone.
                </p>
            </GlassmorphicModal>
        </div>
    );
};

export default ServiceType;